export default __webpack_public_path__ + "static/media/logo-impact-sdg16.d4060979.svg";